import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@app/services/auth/auth/auth.service';
import { isUnguardedPublicRoute } from '@app/pages/public/guards/public.guard';

export const sessionGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (typeof window === 'undefined' || isUnguardedPublicRoute(state.url)) {
    return true;
  }

  if (!authService.getAuthToken() || !authService.hasUser()) {
    authService.clearSession();
    return redirectForInvalidSession(router, state.url);
  }

  return true;
};

function redirectForInvalidSession(router: Router, targetUrl: string): UrlTree {
  if (targetUrl.startsWith('/admin')) {
    return router.createUrlTree(['/']);
  }

  return router.createUrlTree(['/visitor-signup'], {
    queryParams: { redirect: targetUrl },
  });
}
